import { useNavigate } from "react-router";
import { TemplateGalleryView } from "@/components/templates/TemplateGalleryView";

export function TemplateGalleryPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <TemplateGalleryView onBackToEditor={() => navigate("/profile/edit")} />
    </div>
  );
}
